import React, { ReactNode } from 'react'
import { HelpCircle } from 'lucide-react'
import { useModal } from '@/contexts/modal'

interface UseFieldWithHelpOptions {
    modalName: string
    title?: string
}

/**
 * Hook to wrap a form field with a help button that opens a modal
 * @param options - Configuration options
 * @returns A wrapper component that adds help button to any field
 */
export const useFieldWithHelp = (options: UseFieldWithHelpOptions) => {
    const { setModal } = useModal()

    const FieldWithHelp: React.FC<{
        children: ReactNode
        className?: string
    }> = ({ children, className = '' }) => {
        return (
            <div className={`relative ${className}`}>
                {children}
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        setModal(options.modalName)
                    }}
                    className="absolute -right-1 -top-1 p-0.5 text-primary hover:text-primary rounded-full bg-white shadow-sm transition-colors z-10"
                    title={options.title}
                >
                    <HelpCircle size={14} />
                </button>
            </div>
        )
    }

    return { FieldWithHelp }
}

export default useFieldWithHelp
